// redux/actions.js
export const TOGGLE_DAY_NIGHT_MODE = 'TOGGLE_DAY_NIGHT_MODE';

export const toggleDayNightMode = () => ({
  type: TOGGLE_DAY_NIGHT_MODE,
});
